export default class SpreeSdkMethodFromEndpointPathError extends Error {
};
